/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Out_Reason_For_ScentingInputs */

const vi_sl_out_reason_for_scenting = /** @type {(inputs: Sl_Out_Reason_For_ScentingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất đi lấy hương`)
};

/**

* @param {Sl_Out_Reason_For_ScentingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_out_reason_for_scenting = /** @type {((inputs?: Sl_Out_Reason_For_ScentingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Out_Reason_For_ScentingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_out_reason_for_scenting(inputs)
});